var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CopyToClipboardBtn',_vm._b({attrs:{"text":_vm.jsonToText,"disabled":!_vm.items.length}},'CopyToClipboardBtn',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }